export enum OpenMode {
  Standard,
  Modal,
}
